import React from 'react'

const About = () => (
    <p>ATY Creative operates in lovely Vancouver, BC, and is operated by Adam T. Young.</p>
)

export default About